<div class="cell-head">
    <span class="text">{{title}}</span>
    <div *ngIf="info" class="tooltip-icon">
        <nb-icon icon="question-mark-circle-outline"></nb-icon>
    </div>
</div>
